import { recordClickToGtm } from '../lib/login-common';

document.addEventListener('click', e => {
  const targetElement = (e.target as HTMLElement).closest<HTMLElement>('[data-record]');
  if(targetElement) {
    recordClickToGtm(targetElement.dataset.record as string);
  }
});
